import { db } from '../firebase/config';
import {
    doc, getDoc, setDoc, addDoc, collection, updateDoc,
    serverTimestamp
} from 'firebase/firestore';

/**
 * 두 uid를 정렬하여 일관된 roomId 생성
 */
export function getRoomId(uid1, uid2) {
    return [uid1, uid2].sort().join('_');
}

/**
 * 채팅방 생성 (이미 존재하면 skip)
 */
export async function createChatRoom(uid1, uid2, createdBy = 'system', relatedOrderId = null) {
    const roomId = getRoomId(uid1, uid2);
    const roomRef = doc(db, 'chatRooms', roomId);
    const roomSnap = await getDoc(roomRef);

    if (roomSnap.exists()) {
        return { roomId, created: false };
    }

    // 참여자 정보 조회
    const [user1Snap, user2Snap] = await Promise.all([
        getDoc(doc(db, 'users', uid1)),
        getDoc(doc(db, 'users', uid2)),
    ]);

    const user1Data = user1Snap.data() || {};
    const user2Data = user2Snap.data() || {};

    const getDisplayInfo = (data) => ({
        name: data.name || data.displayName || '알 수 없음',
        companyName: data.businessName || data.companyName || '',
        companyType: data.businessType || data.companyBusinessType || '',
    });

    await setDoc(roomRef, {
        roomId,
        type: 'business',
        participants: [uid1, uid2],
        participantInfo: {
            [uid1]: getDisplayInfo(user1Data),
            [uid2]: getDisplayInfo(user2Data),
        },
        lastMessage: '',
        lastMessageTime: serverTimestamp(),
        lastMessageSenderId: '',
        unreadCount: { [uid1]: 0, [uid2]: 0 },
        createdAt: serverTimestamp(),
        createdBy,
        relatedOrder: relatedOrderId,
    });

    return { roomId, created: true };
}

/**
 * 기존 방 확인 후 없으면 생성
 */
export async function getOrCreateChatRoom(uid1, uid2, createdBy = 'system', relatedOrderId = null) {
    const roomId = getRoomId(uid1, uid2);
    const roomRef = doc(db, 'chatRooms', roomId);
    const roomSnap = await getDoc(roomRef);

    if (roomSnap.exists()) {
        return { roomId, created: false };
    }

    return createChatRoom(uid1, uid2, createdBy, relatedOrderId);
}

/**
 * 시스템 메시지 전송
 */
export async function sendSystemMessage(roomId, content) {
    const roomRef = doc(db, 'chatRooms', roomId);
    const messagesRef = collection(db, 'chatRooms', roomId, 'messages');

    await addDoc(messagesRef, {
        senderId: 'system',
        senderName: '시스템',
        type: 'system',
        content,
        createdAt: serverTimestamp(),
        readBy: [],
    });

    await updateDoc(roomRef, {
        lastMessage: content,
        lastMessageTime: serverTimestamp(),
        lastMessageSenderId: 'system',
    });
}
